import Head from 'next/head'
import { useContext, useRef } from 'react'
import { ThemeContext } from 'styled-components'

import AddressHero from 'modules/Home/AddressHero'
import Explainer from 'modules/Home/Explainer'
import FAQ from 'modules/Home/FAQ'
import GetListedOn from 'modules/Home/GetListedOn'
import PricingPlanA from 'modules/Home/PricingPlans'
import SignUp from 'modules/Home/SignUp'
import Testimonials from 'modules/Home/Testimonials'
import FeaturedOnMedia from 'modules/Marketing/FeaturedOnMedia'
import Results from 'modules/Marketing/Results'
import HomePageSlider from 'modules/Sliders/HomePageSlider'

const HomePage = () => {
  const getStartedRef = useRef<HTMLDivElement>(null)

  const scrollTo = () =>
    getStartedRef.current
    && getStartedRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })

  const theme = useContext(ThemeContext)

  return (
    <>
      <Head>
        <title>HomeLister | It’s your equity. Keep more of it.</title>
        <meta
          name="description"
          content="The better way to sell your home is with HomeLister. Keep your equity. Low flat fees. Exceptional service."
        />
        <meta
          name="keywords"
          content="Sell Your Home, Sell My House, For Sale By Owner Alternative, MLS Listing, HomeLister"
        />
      </Head>
      <AddressHero
        title="The Better Way to Sell Your Home"
        subtitle="Keep your equity. Low flat fees. Exceptional service."
        imgSrc={`${process.env.CDN_BASE_URL}/q_auto,w_1280/amazon/assets/suburban-street-yard-sign-overlay-mobile.jpg`}
        tabletImgSrc={`${process.env.CDN_BASE_URL}/q_auto,w_1440/amazon/assets/suburban-street-yard-sign-overlay-tablet.jpg`}
        desktopImgSrc={`${process.env.CDN_BASE_URL}/q_auto,w_1920/amazon/assets/suburban-street-yard-sign-overlay-desktop.jpg`}
      />
      {/* FEATURED ON MEDIA */}
      <FeaturedOnMedia backgroundColor={theme.colors.grey31} />
      {/* SALE PRICE SLIDER */}
      <HomePageSlider scrollTo={scrollTo} />
      {/* CONSIDER IT SOLD */}
      <Explainer scrollTo={scrollTo} />
      {/* PRICING PLANS */}
      <PricingPlanA />
      {/* GET LISTED ON */}
      <GetListedOn />
      {/* RESULTS */}
      <Results />
      {/* TESTIMONIALS */}
      <Testimonials scrollTo={scrollTo} />
      {/* FAQs */}
      <FAQ />
      {/* SIGN UP */}
      <SignUp getStartedRef={getStartedRef} />
    </>
  )
}

export default HomePage
